var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChartEnlarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.864,
    height: 16.729,
    viewBox: "0 0 16.864 16.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-screen",
    transform: "translate(0.277 -562.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52902",
    "data-name": "Path 52902",
    d: "M16.83.676V5.441a.676.676,0,0,1-1.352,0V2.3l-4.6,4.495a.653.653,0,0,1-.946,0,.653.653,0,0,1,0-.946L14.5,1.352H11.389a.676.676,0,1,1,0-1.352h4.765a.8.8,0,0,1,.27.068h.034c.034.034.068.034.135.068L16.661.2,16.7.237c0,.034.034.034.034.068s.034.034.034.068.034.034.034.068,0,.034.034.068c0,.034,0,.034.034.068v.1c-.034-.034-.034,0-.034,0ZM7.03,9.8a.653.653,0,0,0-.946,0l-4.731,4.63V11.254a.676.676,0,0,0-1.352,0v4.9c0,.034,0,.034.034.068,0,.034,0,.034.034.068,0,.034.034.034.034.068s.034.034.034.068.034.034.034.068l.034.034.068.068a.176.176,0,0,0,.135.068H.439a.637.637,0,0,0,.27.068H5.475a.676.676,0,1,0,0-1.352H2.332l4.7-4.6a.694.694,0,0,0,0-.98Z",
    transform: "translate(-0.277 562.36)",
    fill: "#202124"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChartEnlarge);
export default __webpack_public_path__ + "static/media/icon-chart-enlarge.62b23b52.svg";
export { ForwardRef as ReactComponent };